var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading || _vm.loadingDistance,
            expression: "loading || loadingDistance",
          },
        ],
      },
      [_c("progress-bar-loader")],
      1
    ),
    _vm._v(" "),
    _c("div", { class: _vm.progressBarLoadingClass }, [
      !_vm.computedSmallScreen
        ? _c(
            "div",
            { class: { "horizontal-scrollable": _vm.computedAddScroll } },
            [
              _c(
                "ul",
                {
                  ref: "progressBar",
                  staticClass: "progressbar",
                  class: _vm.wrapperClass,
                  style: _vm.progressBarWidthStyle,
                },
                [
                  _c("li", { staticClass: "placeholder-bar" }),
                  _vm._v(" "),
                  _c("li", {
                    staticClass: "fill-bar",
                    style: _vm.fillBarStyle,
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.steps, function (step, index) {
                    return _c("progress-bar-item", {
                      key: step.id || index,
                      class: _vm.assignClass(index),
                      attrs: {
                        step: step,
                        "step-index": index,
                        "selected-steps": _vm.selectedSteps,
                        "custom-render": _vm.customRender,
                      },
                      on: { "select-status": _vm.handleSelectStatus },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (slotProps) {
                              return [
                                _vm._t("default", null, {
                                  step: slotProps.step,
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  }),
                ],
                2
              ),
            ]
          )
        : _c("div", { staticClass: "card mb-0" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body py-0" },
              [
                _c(
                  "material-input",
                  [
                    _c("select2", {
                      attrs: {
                        id: "state-select",
                        data: _vm.steps,
                        value: _vm.selectedSteps,
                        name: "state",
                        options: _vm.options,
                        "format-data": _vm.formatData,
                      },
                      on: { change: _vm.handleSelectStatus },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header bb-0 pb-0" }, [
      _c("p", { staticClass: "bold text-primary font-sm mb-2" }, [
        _vm._v("Change Status"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }